export enum EControleEtat {
    OK = "OK",
    WARNING = "Warning",
    DISABLED = "Disabled",
    ERROR = "Error"
}
